export function CheckInputValue(_idElem) {
  let input = document.getElementById(_idElem);
  if (input) {
    try {
      input = parseFloat(input.value);
      if (input < 0) {
        return false;
      }
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
  return true;
}
